export enum FetchStatus {
  FETCHING = 'FETCHING',
  USER_AUTH_CHECK = 'USER_AUTH_CHECK',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  UNSETTLED = ''
}

export interface UserData {
  login?: string;
  errorStatus?: number;
}

export interface User {
  fetchStatus: FetchStatus;
  data: UserData;
  jwt: string;
  refreshToken: string;
}
